// Finding the picture for a product number.
//
// This was copied into four pages, in two variants that disagreed about what to
// do when there is no picture: two returned undefined and two returned
// '/placeholder-device.png', a file that does not exist. Both render as the
// browser's broken-image icon, which is why a device with no asset looked like
// broken data rather than a product nobody has photographed yet.
//
// Only 117 products have an image, so the miss is the common case, not the edge
// one. It returns null here and ProductThumb draws something deliberate.

let productImages;
try {
  productImages = require.context('./product-images', false, /\.(png|jpe?g|svg)$/);
} catch (e) {
  // No webpack context (tests, SSR). Every lookup misses, which is handled.
  productImages = null;
}

/** The image URL for a product number, or null when nothing matches. */
export function getProductImage(name) {
  if (!productImages || !name) return null;
  for (const file of [`./${name}.png`, `./${name}.jpg`, `./${name}.jpeg`, `./${name}.svg`]) {
    try {
      return productImages(file);
    } catch (e) {
      // try the next extension
    }
  }
  return null;
}
